import React from "react";
import { useConfig, ModuleLoader } from "@eis-poc/lib-discover-medical-mfes";
import App from "../../App";
import Alerts from "../Alerts";
import Banner from "../Banner";
import Announcements from "../Announcements";
import { ContentWrapper } from "../../App.styled";
import { PrimaryContent, SecondaryContent } from "./_.styled";
import hero from "../../img/hero-dmp.jpg";
import FeatureCards from "../SiteFeatures";
import CallToActionCard from "../CallToActionCard";
import ErrorBoundary from "../ErrorBoundary";
import PromotedTool from "../PromotedTool";

function HomeDMX() {
  const configData = useConfig();
  const CEWidgetConfig = configData?.mfes["PlatformCEHomeWidget"];

  return (
    <App>
      <Banner hero={hero} />
      <ContentWrapper container>
        <PrimaryContent as={Alerts} mobileOrder={3} />
        {CEWidgetConfig && (
          <SecondaryContent mobileOrder={5}>
            <ModuleLoader
              remoteUrl={CEWidgetConfig.remoteUrl}
              module={CEWidgetConfig.module}
              containerName={CEWidgetConfig.containerName}
            />
          </SecondaryContent>
        )}
        <ErrorBoundary team="cd.bauhaus">
          <SecondaryContent as={CallToActionCard} mobileOrder={1} />
        </ErrorBoundary>
        <ErrorBoundary team="cd.bauhaus">
          <SecondaryContent as={PromotedTool} mobileOrder={2} />
        </ErrorBoundary>
        <ErrorBoundary team="cd.bauhaus">
          <SecondaryContent as={Announcements} mobileOrder={4} />
        </ErrorBoundary>
        <ErrorBoundary team="cd.bauhaus">
          <SecondaryContent as={FeatureCards} mobileOrder={6} />
        </ErrorBoundary>
      </ContentWrapper>
    </App>
  );
}

export default HomeDMX;
